export const formatNumber = (number: number) => {
  return number.toString().padStart(2, '0')
}

type TimerCoundDownConfig = {
  blindTime: number
  remainingTime: number
  nextSmallBlind: number
  gameStartTime: number
}

export const timerCountDown = ({ blindTime, remainingTime, nextSmallBlind, gameStartTime }: TimerCoundDownConfig) => {
  const initialMinutes = formatNumber(0)
  const initialSecond = formatNumber(0)
  const remainingMinutes = formatNumber(Math.abs(Math.floor(remainingTime / 60)))
  const remainingSeconds = formatNumber(Math.floor(remainingTime % 60))

  return Number(nextSmallBlind) !== 0 && gameStartTime > 0
    ? {
        minutes: remainingTime < blindTime ? remainingMinutes : initialMinutes,
        seconds: remainingTime < blindTime ? remainingSeconds : initialSecond
      }
    : {
        minutes: '--',
        seconds: '--'
      }
}
